<template>
    <!-- ========================================================================================================================= -->
    <v-text-field v-if="fielddef.input_type=='text' "
                  ref="input"
                  :value="value[fielddef.name]"
                  @input="updateValue"
                  @blur="formatValue"
                  :required="$v.value.fieldValues[fielddef.name].required"
                  :label="fielddef.label"
                  :hint="hint"
                  :rules="[() => ( $v.value.fieldValues[fielddef.name].$error ? errorMessage(fielddef.name) : true )]"
                  :error-messages="$v.value.fieldValues[fielddef.name].$error ?  errorMessage(fielddef.name) : []"
                  @formStateChanged="handle_parentForm_validateStateChanged"
                  :disabled="disabled ? disabled : false"
                  :class="{'input-group--error':$v.value.fieldValues[fielddef.name].$error }"
                  :suffix="suffix"
                  :single-line="singleLine ? singleLine : false"

                  :return-masked-value="true"
                  :mask="mask"


    ></v-text-field>

    <!-- ========================================================================================================================= -->
    <v-select v-else-if="fielddef.input_type=='select' "
              ref="input"
              :value="value[fielddef.name]"
              @input="updateValue"
              :required="$v.value.fieldValues[fielddef.name].required"
              :label="fielddef.label"
              :hint="hint"
              :error-messages="$v.value.fieldValues[fielddef.name].$error ?  errorMessage(fielddef.name) : []"
              :rules="[() => ( $v.value.fieldValues[fielddef.name].$error ?  errorMessage(fielddef.name) :  true )]"
              :items="fielddef.selectOptions"
              :disabled="disabled ? disabled : false"
              :autocomplete="autocomplete ? true : false"


    >
        <template slot="item" slot-scope="data">
            <div v-if="data.item.hidden!==true" :style="data.item.disabled ? {color:'#d88'} : {}">{{data.item.text}}</div>
        </template>
    </v-select>
    <!-- ========================================================================================================================= -->

    <v-date-picker v-else-if="fielddef.input_type=='datepicker'"
                   landscape
                   ref="input"
                   :value="value[fielddef.name]"
                   @input="updateValue"
                   :required="$v.value.fieldValues[fielddef.name].required"
                   :label="fielddef.label"
                   :hint="hint"
                   :rules="[() => ( $v.value.fieldValues[fielddef.name].$error ?  errorMessage(fielddef.name) :  true )]"
                   :disabled="disabled ? disabled : false"

    >
    </v-date-picker>

    <!-- ========================================================================================================================= -->
    <!--
        <v-layout row v-else-if="fielddef.input_type=='radio' "
                  class="my_radio input-group input-group--text-field input-group--dark "
                  :class="{'input-group--error':$v.value.fieldValues[fielddef.name].$error, 'input-group--required':$v.value.fieldValues[fielddef.name].required}"
        >


    <v-flex xs12 class="subheading my_radio_label ">
        <label class="blue-grey--text darken-4">{{fielddef.label}}</label>
    </v-flex>

    <v-flex v-bind="conditionalAttributes(index)">
    -->
    <v-radio-group v-else-if="fielddef.input_type=='radio' "
                   class="my_radio_group"
                   :label="fielddef.label"
                   v-bind="conditionalAttributes()"
                   :rules="[() => ( $v.value.fieldValues[fielddef.name].$error ? errorMessage(fielddef.name) : true )]"
                   :error-messages="$v.value.fieldValues[fielddef.name].$error ?  errorMessage(fielddef.name) : []"
                   :disabled="disabled ? disabled : false"

                   v-model="value[fielddef.name]"

    >

        <v-radio v-for="(item, index) in fielddef.selectOptions"
                 :required="$v.value.fieldValues[fielddef.name].required"
                 :key="fielddef.name+'-'+item.value"
                 class="my_radio_input"
                 :style="get_sub_styles(index)"
                 :class="{first: index==0, last:(index==fielddef.selectOptions.length-1)}"
                 :label="item.text"
                 :rules="[() => ( $v.value.fieldValues[fielddef.name].$error ? errorMessage(fielddef.name) : true )]"
                 :value="item.value"
                 @change="updateValue"
                 xs3

        ></v-radio>

    </v-radio-group>
    <!--
        </v-flex>

        <v-flex xs12 class="my_radio_group__details input-group__error input-group__details ">
            <div class="input-group__messages">
                <div class="input-group__error" v-if="$v.value.fieldValues[fielddef.name].$error">
                    {{errorMessage(fielddef.name)}}
                </div>
            </div>

        </v-flex>


            </v-layout>
            -->
    <!-- ========================================================================================================================= -->

</template>
<!-- _____________________________________________________________________________________________________________________________________________________________ -->
<!-- ############################################################################################################################################################# -->
<script>
    //import Vue from 'vue'
    import validators from '@/validators'
    import _ from 'lodash'

    export default {
        //========================================================================================================
        name: 'Rechner-field-col',
        //========================================================================================================
        data: function () {
            return {
                localValue: null
            }
        }, //=====================================================================================================
        props: [
            'value',
            'fielddef',
            '$v',
            'disabled',
            'hint',
            'suffix',
            'radioWidths',
            'direction',
            'main_style',
            'sub_styles',
            'singleLine',
            'autocomplete',
            'mask',
        ],
        //========================================================================================================
        methods: {
            //—————————————————————————————————————————————————————————————————————————————————
            formatValue: function () {
                var val = this.value[this.fielddef.name]
                //if (val !== 'asas') {
                var validate = this.fielddef.validate
                console.log("%%%%%%%%%%%% " + this.fielddef.name + " BLUR: value:", val, 'validate:', validate)
                var newVal = val

                this.$nextTick(function () {
                    if (validate.hasOwnProperty('integer')) {
                        newVal = this.$numeral(val).format('0,0')
                    }
                    if (validate.hasOwnProperty('float')) {
                        newVal = this.$numeral(val).format('0,0.(000)')
                    }
                    if (validate.hasOwnProperty('currency')) {
                        newVal = this.$numeral(val).format('0,0.00')
                    }

                    if (newVal !== val) {
                        console.log("%%%%%%%%%%%% oldVal <> newVal:", val, newVal)
                        this.$refs.input.$el.querySelector("input").value = newVal
                        this.updateValue(newVal)
                    }
                })
                //}
            },
            //—————————————————————————————————————————————————————————————————————————————————
            updateValue: function (val) {
                /*
                        var validate = this.fielddef.validate
                        if (validate.hasOwnProperty('plz')) {
                          var fieldNameOrt = this.fielddef.name.replace('plz', 'ort')
                          console.log("@ @ @ @ @ @ test", fieldNameOrt, this.value)
                          if (this.value.hasOwnProperty(fieldNameOrt) && val.length === 5) {
                            console.log("@ @ @ @ @ @ OKI", fieldNameOrt)

                            var url = "http://api.zippopotam.us/de/" + val
                            Vue.http.get(url).then(response => {
                              console.log("IBAN response:", response.body)
                              var data = response.body
                              for (var index in data.places) {
                                var place = data.places[index]
                                console.log("place ", place)
                              }
                            }, response => {
                              console.log("IBAN DATA ! ERROR ! :", response)

                            })
                          }
                        }
                */


                console.log("§§§§§§§§ UPDATE:", val)
                this.$v.value.fieldValues[this.fielddef.name].$touch()
                this.value[this.fielddef.name] = val
                this.$emit('input', this.value)

            }, //——————————————————————————————————————————————————————————————————————————————
            handle_parentForm_validateStateChanged: function (data) {
                /*
                 //console.log('updateValidState...', data)
                 var step = this.getStepByNr(data.senderStep);
                 step.isValid = data.isValid
                 step.hasErrors = data.hasErrors
                 //console.log("test updateFormState:", step, data.senderStep);
                 var state = true;
                 var stepName;
                 for (stepName in this.steps) {
                 // console.log(stepName, this.steps[stepName].frmValid)
                 state = state && this.steps[stepName].frmValid;
                 }
                 this.test = state;
                 */
            }, //——————————————————————————————————————————————————————————————————————————————
            errorMessage: function (key) {
                var allInfos = [];

                for (var errorKey in validators.errorMsg) {
                    if (this.$v.value.fieldValues[key][errorKey] === false) {
                        var msg = validators.errorMsg[errorKey](key, this.$v.value.fieldValues, this.fielddef.validate);
                        allInfos.push(msg)
                    }
                }

                allInfos = allInfos.join(' | ')
                return allInfos

            }, //——————————————————————————————————————————————————————————————————————————————
            conditionalAttributes: function (index) {


                var attributes = {};
                //......................................................................................

                if (this.radioWidths) {
                    console.log("@ @ @ @ @ @ @ @ (" + this.fielddef.name + ")", this.radioWidths);
                    var defs = this.radioWidths;

                    if (_.isObject(defs)) {
                        _.forEach(defs, (BreitenArray, viewport) => {
                            var breite = BreitenArray[index];
                            console.log("# # # # O:", defs, index, viewport + breite);
                            attributes[viewport + breite] = null
                        })

                    } else if (_.isArray(defs)) {
                        console.log("# # # # XXX:", defs);
                        var breite = defs[index];
                        console.log("# # # # A:", defs, index, 'xs' + breite);
                        attributes['xs' + breite] = null

                    } else if (parseInt(defs, 10) > 0) {
                        console.log("# # # # N:", defs, index, 'xs' + defs);
                        attributes['xs' + defs] = null

                    } else {
                        attributes['xs4'] = null
                    }
                }
                //......................................................................................
                if (this.direction) {
                    var direction = this.direction;
                    //console.log("@ @ @ @ @ @ @ @", direction);
                    attributes = {[direction]: true}
                }
                //......................................................................................
                return attributes
            }, //——————————————————————————————————————————————————————————————————————————————
            get_sub_styles: function (index) {
                if (this.sub_styles) {
                    return this.sub_styles[index]
                } else {
                    if (this.fielddef.input_type === 'radio' && this.fielddef.selectSource === 'typ_ja_nein') {
                        return {minWidth: '50px', maxWidth: '200px'}
                    }
                }


            }, //——————————————————————————————————————————————————————————————————————————————
        }, //========================================================================================================
        mounted() {

            this.$watch(
                '$v',
                function (newVal, oldVal) {
                    //console.log(this, "############# $forceUpdate #################")
                    this.$forceUpdate()


                },
                {
                    deep: true
                }
            )

        }
        ,
    }
</script>
<!-- ############################################################################################################################################################# -->
<!-- ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯ -->
<style>

    /* ******************************************************************************
      ! ! ! FIX für DropDown-Knopf recht vom Select-Input
      ohne Fix geht dropt das Select nicht beim Klick auf den 'runter-Pfeil '*/
    .input-group--select .menu {
        width: 36px;
        margin-right: -36px;
    }

    /* ***************************************************************************** */
    .v-radio.my_radio_input.last {
        margin-bottom: 3px !important;
    }


    .my_radio_group.special_radio .v-input__control{
        margin-top: 3px  !important;
    }
    .my_radio_group.special_radio.v-input--selection-controls.v-input--radio-group--row .v-input__slot{
        margin-bottom:  0.25px  !important;
     }
    .my_radio_group.special_radio .v-input--radio-group__input>label{
        margin: 0 0 3px 0;
    }
    .my_radio_group.special_radio .v-input__slot{
        margin-bottom: -3px  !important;
    }
    div.my_radio_group.v-input--radio-group div.v-input__control {

        width: 100% !important;
    }


    .v-input--radio-group--row .v-input__control {
        flex-grow: 1 !important;
    }

    .v-input--radio-group--row .v-radio.my_radio_input .v-input--selection-controls__input {
        margin: 0 1px 0 0;
    }

    .v-input--radio-group--row .v-radio.my_radio_input {
        margin-right: 20px;
    }

    .v-input--radio-group--row .v-radio.my_radio_input:last-child {
        margin-right: 25px;
    }

    .v-input--selection-controls.my_radio_group{
        margin-top: 12px !important;
        margin-bottom: 4px !important;
    }

    .v-input--selection-controls.v-input--radio-group--row .v-input__slot {
        margin-bottom: 4px !important;
        margin-top: 11px !important;
        /*
                margin-bottom: 4px !important;
                margin-top: 16px !important;
                */
    }

    .v-input--radio-group .v-messages {
        border-top: 1px solid;
    }

    .v-input--radio-group--row .v-input--radio-group__input {
        justify-content: space-between;
        flex-wrap: unset !important;
    }

    div.special_radio {
        margin-top: 10px;
    }

    .special_radio .v-input--radio-group__input > label.v-label {
        white-space: nowrap;
        min-width: 360%;
        max-width: 360%;
        position: absolute !important;
        top: auto;
        bottom: 20px;
        font-size: 0.8em;
        line-height: 1.1em;
        flex-grow: 1 !important;
    }

    .v-input--radio-group__input > label.v-label {

        flex-grow: 1 !important;
        flex-basis: 30%;
    }

    div.v-radio.my_radio_input label.v-label {
        top: 3px;

    }

    .v-input--radio-group__input > .v-radio.my_radio_input {
        height: 17px;
    }

    .v-list__tile div {
        text-align: left;
        border-bottom: 1px solid #e2dede;
        XXXbox-shadow: -2px 3px 6px 0px #ececec;
        position: relative;
        line-height: 1.3em;
        font-size: 0.95em;
    }

    .v-list__tile div:after {
        background-color: #f6f6f6;
        width: 100%;
        min-width: 1000px;
        height: 2px;
        position: absolute;
        content: " ";
        left: 0;
        bottom: -3px;
    }


    v-input v-input--selection-controls v-input--radio-group v-input--radio-group--column v-input--is-label-active v-input--is-dirty theme--light
        /*
            .v-input--radio-group .v-messages {
                border-top: 1px solid;
            }

            .v-input--radio-group label {
                height: auto;
                white-space: normal;
            }

            .v-input--radio-group--row .v-radio.my_radio_input{
                margin-right:8%;
            }
            .v-input--radio-group--row .v-radio.my_radio_input.last{
                margin-right:2px;
            }

            .v-input--radio-group--row .v-input--radio-group__input > label {
                width: 100%;

            }

            .v-input--selection-controls.v-input--radio-group--row .v-input__slot{
                margin-bottom: 3px;
            }

            .v-input--radio-group--row .v-radio.my_radio_input2 {
                margin-top: 0.3em;
                margin-bottom: -0.55em;
            }

            .v-input--radio-group--row .v-radio.my_radio_input,
            .v-input--radio-group .v-radio.my_radio_input:not(:last-child):not(:only-child){
                margin-bottom: 1px;
            }

            .v-input--radio-group--row .v-messages.error--text {
                padding-top: 5px;
            }
        */
        /*
        .my_radio .flex {
            padding-left: 0;

        }

        .flex.my_radio_label {
            margin: 0px 0 -6px 0;

            text-align: left;

        }

        .flex.my_radio_label label {
            line-height: 1em;

        }

        .radio_text_row .flex.my_radio_label {
            margin-bottom: -326px;

        }
    */
    .my-form-container .flex {
        padding: 0 4px;
    }

    .input-group {
        margin: 0px 0px;
        /* min-height: 24px; */
        padding: 15px 0 0;
    }

    /*
        .input-group__input {
            min-height: 24px;

        }

        .input-group--text-field input {
            height: 24px;
            margin-top: 0px;
        }

        .input-group--select .input-group__selections__comma {
            height: 24px;
            padding-top: 1px;
        }

        .radio_text_row.input-group {
            margin-bottom: 2px;
        }

        .my_radio_input.input-group {
            margin: 3px;
        }

        .radio_text_row.input-group.input-group--text-field {
            margin-top: 20px;
        }

        /*
            .my_radio.input-group.input-group--text-field {
                margin: 0px 0 8px 0;
            }

            .flex.my_radio_label label {
                position: relative;
                white-space: inherit;
            }

            .my_radio .my_radio_input label:after {
                content: ''
            }

            .my_radio_group__details {
                margin: 0px 0 0px 0;

            }
        */
    /*
    .radio_text_row .my_radio_group__details {
        margin: -26px 0 0px 0;

    }

    .list__tile {
        height: auto;
        border-bottom: solid 1px #ddd;
    }

    li:last-child .list__tile {
        border-bottom: none;
    }

    .input-group--text-field.input-group--light label {

    }

    .input-group--text-field.input-group--dark label {
        color: rgba(50, 50, 100, 0.48);
    }

    .input-group--text-field.input-group--focused label,
    .input-group--text-field.input-group--dirty label {
        transform: translate3d(0, -18px, 0) scale(.9);
        color: rgba(50, 50, 100, 0.65);
    }

    .input-group--text-field.input-group--error .input-group__details:before,
    .input-group--text-field.input-group--error .input-group__details:after {
        background-color: #f44336;
    }

    .input-group--dark .input-group__details:before {

    }

    .input-group--text-field.input-group--focused.input-group--error label,
    .input-group--text-field.input-group--dirty.input-group--error label,
    .input-group--text-field.input-group--error label {
        color: #f44336 !important;
    }

    .input-group label {
        max-width: 100%;
    }
*/


</style>
